import { AfterViewInit, Component, OnInit } from '@angular/core';
import { EVENTS, TrackingService } from '@clooper/core';

@Component ({
  selector: 'app-install-prompt',
  styleUrls: ['./install-prompt.component.scss'],
  templateUrl: './install-prompt.component.html'
})
export class InstallPromptComponent implements OnInit {

  installEvent: any;

  show: boolean = false;

  constructor(
    private tracker: TrackingService
  ) { }

  ngOnInit(): void {
    window.addEventListener('beforeinstallprompt', (event) => {
      event.preventDefault();
      this.installEvent = event;
      // if (!this.getVisited()) {
      this.show = true;
      // } else {
      // this.tracker.track(EVENTS.LAUNCH_PWA, {});
      // }
    });

    // Detect when the PWA was successfully installed
    window.addEventListener('appinstalled', (evt) => {
      // Log install to analytics
      this.tracker.track(EVENTS.INSTALL_PWA, {});
    });

    // Track how the PWA was launched
    window.addEventListener('DOMContentLoaded', () => {
      let displayMode = 'browser tab';
      if ((navigator as any).standalone) {
        displayMode = 'standalone-ios';
        this.tracker.track(EVENTS.LAUNCH_PWA, {});
      }
      if (window.matchMedia('(display-mode: standalone)').matches) {
        displayMode = 'standalone';
        this.tracker.track(EVENTS.LAUNCH_PWA, {});
      }
      // Log launch display mode to analytics
      // console.log('DISPLAY_MODE_LAUNCH:', displayMode);

      // Track when the display mode changes
      // tslint:disable-next-line: deprecation
      window.matchMedia('(display-mode: standalone)').addListener((evt) => {
        if (evt.matches) {
          displayMode = 'standalone';
        }
        // Log display mode change to analytics
        // console.log('DISPLAY_MODE_CHANGED', displayMode);
      });
    });
  }

  getVisited (): boolean {
    return false
  }

  setVisited () {

  }

  install() {
    this.show = false;
    this.installEvent.prompt();
    this.installEvent.userChoice.then((choice: any) => {
      if (choice.outcome !== 'accepted') {
        this.setVisited();
      }
      this.installEvent = null;
    });
  }

  close() {
    this.setVisited();
    this.show = false;
    this.installEvent = null;
  }

}
